import React, { useState } from 'react';

/** Logo with graceful text fallback when the file is not uploaded yet. */
const LogoOrName = ({ partner, onDark, size = 'md' }) => {
  const [failed, setFailed] = useState(false);
  const src = onDark && partner.logoOnDark ? partner.logoOnDark : partner.logo;
  const h = size === 'sm' ? 'h-5 md:h-6' : 'h-7 md:h-9';

  if (failed || !src) {
    return (
      <span
        className={`font-bold uppercase tracking-[0.18em] whitespace-nowrap ${
          size === 'sm' ? 'text-[10px] md:text-xs' : 'text-xs md:text-sm'
        } ${onDark ? 'text-white' : 'text-[#1B1B1B]'}`}
        style={{ fontFamily: 'DM Sans, sans-serif' }}
      >
        {partner.name}
      </span>
    );
  }

  return (
    <img
      src={src}
      alt={partner.name}
      onError={() => setFailed(true)}
      loading="lazy"
      className={`${h} w-auto object-contain ${
        onDark && !partner.logoOnDark ? 'brightness-0 invert' : ''
      }`}
    />
  );
};

/** Camption × 49W × Rasyo Community lockup. */
const PartnerStrip = ({ partners, onDark = true, size = 'md', testId = 'event-partner-strip' }) => (
  <div
    data-testid={testId}
    className="flex items-center gap-3 md:gap-5 flex-wrap"
  >
    {partners.map((p, i) => (
      <React.Fragment key={p.key}>
        {i > 0 && (
          <span
            aria-hidden="true"
            className={`h-4 md:h-5 w-px ${onDark ? 'bg-white/30' : 'bg-[#1B1B1B]/20'}`}
          />
        )}
        <LogoOrName partner={p} onDark={onDark} size={size} />
      </React.Fragment>
    ))}
  </div>
);

export default PartnerStrip;
